export default "__VITE_ASSET__a8dd9e14__"